var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-bg-white u-flex u-items-start u-text-small u-text-dark-5 u-mt-2 u-p-3"},[_c(_setup.IconValidationInfo,{staticClass:"u-pt-1p"}),_c('span',{staticClass:"u-pl-2",domProps:{"innerHTML":_vm._s(_vm.t('Shared.Validation.UsernameRequirements'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }